import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-pcomp-bscollapse',
	templateUrl:'./BSCollapsePluginCompPage.html',
	styles: [],
	styleUrls:['./BSCollapsePluginCompPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class BSCollapsePluginCompPage
{
	mdContent_803 = `\`\`\`java
import com.jwebmp.plugins.bootstrap.collapse.BSCollapse;
\`\`\``;
	mdContent_804 = `\`\`\`java
DivSimple&lt;?&gt; content = new DivSimple&lt;&gt;();
content.setText("Collapsible content");
BSButton&lt;?&gt; trigger = new BSButton&lt;&gt;("Toggle");
BSCollapse.link(trigger, content, true);
\`\`\``;
}
